/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T10:19:45.938
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCCBFinBillEditInit,
	getCCBFinBillView
} from '@api/house/CCBFinBill';

import {
listCCBFinBillItemInit,
listCCBFinBillItemByAuthorizations,
deleteCCBFinBillItem
} from '@api/house/CCBFinBillItem';

import {
listCCBSyncLogInit,
listCCBSyncLogByAuthorizations,
deleteCCBSyncLog
} from '@api/house/CCBSyncLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getCCBFinBillEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBFinBillView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
